import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { LOGIN_USER } from '../store/actions/user.actions';
import { PPAPI } from '../config/privyConfig';

/**
 * Fallback sign-in without Privy: our own 6-digit email code
 * (requestEmailLoginOtp / confirmEmailLoginOtp on ppapi). Kept for partners
 * who cannot complete a Privy login on their device; mints the same session.
 */
export const useEmailOtpLogin = () => {
    const dispatch = useDispatch();

    const requestEmailLoginOtp = useCallback(async (email) => {
        try {
            const res = await axios.post(PPAPI, { requestEmailLoginOtp: true, email, urlUsed: window.location.href });
            if (res.data?.response?.sent) return { ok: true };
            return { ok: false, error: res.data?.response?.error || 'Could not send the code. Please try again.' };
        } catch (e) {
            return { ok: false, error: e?.response?.data?.response?.error || 'Could not send the code. Please try again.' };
        }
    }, []);

    const confirmEmailLoginOtp = useCallback(async (email, code, twoFactorCode) => {
        try {
            const payload = { confirmEmailLoginOtp: true, email, code, urlUsed: window.location.href };
            if (twoFactorCode) payload.twoFactorCode = twoFactorCode;
            const res = await axios.post(PPAPI, payload);
            const data = res.data?.response;
            if (data && data.hash) {
                localStorage.removeItem('impersonation');
                localStorage.setItem('hash', data.hash);
                localStorage.setItem('username', data.email || email);
                localStorage.setItem('expirationTime', new Date().getTime() + 14400000);
                localStorage.setItem('affiliateId', data.affiliateId);
                sessionStorage.removeItem('manualLogout');
                dispatch({ type: LOGIN_USER, payload: res.data });
                toast.success('Signed in successfully!');
                return { ok: true };
            }
            return { ok: false, error: data?.error || 'Invalid or expired code.' };
        } catch (e) {
            if (e?.response?.status === 401 && e?.response?.data?.twoFactorRequired) {
                return { ok: false, twoFactor: true };
            }
            return { ok: false, error: e?.response?.data?.response?.error || 'Invalid or expired code.' };
        }
    }, [dispatch]);

    return { requestEmailLoginOtp, confirmEmailLoginOtp };
};

export default useEmailOtpLogin;
